module.exports = __webpack_public_path__ + "static/preciadores-424eaacb078a5b06c222257694c2f0f3.svg";